const currencyInterval = setInterval(appendCurrencyToHeader, 500);
function appendCurrencyToHeader() {
    const currencyBlocker = document.querySelector('.bacurr-cur-blocker');
    const currencyBlock = currencyBlocker.firstElementChild;
    
    if (currencyBlocker != null) {
        if (window.screen.width >= 768) {
            const header = document.querySelector('.header__column--right')
            currencyBlock.style.position = "relative";
            currencyBlock.style.right = "unset";
            currencyBlock.style.top = "unset";
            header.insertAdjacentElement('afterbegin', currencyBlocker)
            clearInterval(currencyInterval)
        } else {
            const menuDrawer = document.querySelector('.menu-drawer');
            const currDropdown = document.querySelector('.bacurr-dropdown-choices');
            menuDrawer.insertAdjacentElement('afterbegin', currencyBlocker);
            currDropdown.style.left = "10px !important";
            clearInterval(currencyInterval);
        }
    }
}